export default __webpack_public_path__ + "static/media/Screenshot 2024-02-16 at 6.51.38â¯PM.bd40dc57.png";